import { NgModule, Injector } from '@angular/core';
import { AppComponent } from './app.component';
import { MatIconModule  } from '@angular/material/icon';
import { MatMenuModule  } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocalCommonModule } from './common.module';
import { BottomMenuComponent } from './Components/Menu/bottommenu.Component';
import { setAppInjector } from './Services/AppInjector';
import { AppRoutingModule } from './app-routing.module';
import { AdminMenuComponent } from './Components/Menu/adminMenu.Component';
import { MenuComponent } from './Components/Menu/menu.Component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChecklistTaskEditComponent } from './Components/Checklist/ChecklistTaskComponentEdit';
import { ConfigService } from './Services/ConfigService';
import { TrialPopUpComponent } from './Components/Menu/trialPopUpComponent';
import { PageHelpComponent } from './Components/Partials/PageHelpComponent';

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		LocalCommonModule.forRoot(),
		HttpClientModule,
		AppRoutingModule,
		MatMenuModule,
		MatIconModule,
	],
	exports: [
		BrowserModule,
		BrowserAnimationsModule,
	],
	declarations: [
		AppComponent,
		MenuComponent,
		AdminMenuComponent,
		TrialPopUpComponent,
		BottomMenuComponent,
		ChecklistTaskEditComponent,
		//PageHelpComponent
	],
	bootstrap: [
		AppComponent
	],
	providers: [
		ConfigService,
	]
})
export class AppModule {
	constructor(injector: Injector) {
		setAppInjector(injector);
	}
}
